export default __webpack_public_path__ + "static/media/gmap.9cd98cdf.png";